import { PageHero } from "@/components/PageHero";
import { About } from "@/components/About";
import { Team } from "@/components/Team";
import { Stats } from "@/components/Stats";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowUpRight } from "lucide-react";

export default function WhoWeAre() {
  return (
    <>
      <PageHero
        eyebrow="Who We Are · 01"
        title="A Southern California"
        italic="land partner."
        subtitle="35+ years across land development, large-scale real estate, and homebuilding — with a current focus on land entitlement and executive management."
        image="https://images.pexels.com/photos/8961260/pexels-photo-8961260.jpeg"
      />

      <About />
      <Stats />
      <Team />

      {/* Next page CTA */}
      <section className="bg-paper py-20 lg:py-28 border-t border-border">
        <div className="mx-auto max-w-[1400px] px-6 lg:px-10 grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12">
          <Link to="/team" className="group bg-secondary border border-border p-8 lg:p-10 hover:border-clay transition-colors flex flex-col">
            <span className="mono text-[10px] uppercase tracking-[0.25em] text-clay">Up next</span>
            <h3 className="font-display text-3xl lg:text-5xl text-ink mt-3 leading-tight tracking-[-0.02em]">Meet the team</h3>
            <p className="mt-4 text-foreground/70 flex-1">The senior people leading RCCD's specific-plan and executive management work.</p>
            <div className="mt-6 inline-flex items-center gap-2 mono text-[11px] uppercase tracking-[0.22em] text-ink group-hover:text-clay">
              See the team <ArrowUpRight className="h-3.5 w-3.5 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
            </div>
          </Link>
          <Link to="/what-we-do" className="group bg-secondary border border-border p-8 lg:p-10 hover:border-clay transition-colors flex flex-col">
            <span className="mono text-[10px] uppercase tracking-[0.25em] text-clay">Then</span>
            <h3 className="font-display text-3xl lg:text-5xl text-ink mt-3 leading-tight tracking-[-0.02em]">What we do</h3>
            <p className="mt-4 text-foreground/70 flex-1">Four disciplines, one practice — from feasibility through council adoption.</p>
            <div className="mt-6 inline-flex items-center gap-2 mono text-[11px] uppercase tracking-[0.22em] text-ink group-hover:text-clay">
              Our practice <ArrowUpRight className="h-3.5 w-3.5 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
            </div>
          </Link>
        </div>
      </section>
    </>
  );
}
